"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFormattedText = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function AddressFormattedText(_a) {
    var address = _a.address;
    if (!address)
        return react_1.default.createElement("div", null);
    var addressLine1 = address.addressLine1, addressLine2 = address.addressLine2, city = address.city, displayName = address.displayName, stateOrArea = address.stateOrArea, postalCode = address.postalCode;
    return (react_1.default.createElement(core_ui_1.Text, { size: "small", color: "default" },
        displayName && react_1.default.createElement("div", null, displayName),
        react_1.default.createElement("b", null, addressLine1),
        addressLine2 && react_1.default.createElement("div", null, addressLine2),
        react_1.default.createElement("div", null,
            city,
            ", ",
            stateOrArea,
            ", ",
            postalCode)));
}
exports.AddressFormattedText = AddressFormattedText;
